// extracted by mini-css-extract-plugin
export default {"common":"\"../../styles/common.css\"","flex_middle":"common_flex_middle__Fngdy","spinner":"styles_spinner__rlI86","centered":"styles_centered__QOd70 common_flex_middle__Fngdy"};